





















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AppAccordion extends Vue {
  @Prop({ type: Boolean, default: false })
  public isExpanded!: boolean;

  toggleExpand(): void {
    this.$emit('update:is-expanded', !this.isExpanded);
  }
}
